module.exports = __webpack_public_path__ + "media/images/item/reco_bg-932ac555d499c3a045ee009095aab402.gif";